module.exports = __webpack_public_path__ + "img/keder_grau_candy.cad9bc9f.jpg";